import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import all translation files as before
import EmailVerificationEL from '../locales/el/email_verification.json';
import featuresEL from '../locales/el/features.json';
import loginEL from '../locales/el/login.json';
import mapsEL from '../locales/el/maps.json';
import translationEL from '../locales/el/translation.json';
import EmailVerificationEN from '../locales/en/email_verification.json';
import featuresEN from '../locales/en/features.json';
import loginEN from '../locales/en/login.json';
import mapsEN from '../locales/en/maps.json';
import translationEN from '../locales/en/translation.json';

const isProduction = import.meta.env.NODE_ENV === 'production';

const resources = {
  en: {
    translation: translationEN,
    login: loginEN,
    email_verification: EmailVerificationEN,
    features: featuresEN,
    maps: mapsEN
  },
  el: {
    translation: translationEL,
    email_verification: EmailVerificationEL,
    login: loginEL,
    features: featuresEL,
    maps: mapsEL
  }
};

// Custom formatter function
const initFormatter = (i18next) => {
  i18next.services.formatter.add('uppercase', (value, lng, options) => {
    return typeof value === 'string' ? value.toUpperCase() : value;
  });
  
  i18next.services.formatter.add('lowercase', (value, lng, options) => {
    return typeof value === 'string' ? value.toLowerCase() : value;
  });
  
  i18next.services.formatter.add('capitalize', (value, lng, options) => {
    if (typeof value !== 'string') return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  });
  
  // Add more custom formatters as needed
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "el"],
    
    // Namespace configuration
    ns: ["translation", "login", "features", "maps", "email_verification"],
    defaultNS: "translation",

    // Detection configuration
    detection: {
      order: ["cookie", "localStorage", "navigator"],
      caches: ["cookie"],
      lookupCookie: "i18nextLng",
      cookieOptions: {
        path: '/',
        sameSite: 'lax',
        secure: isProduction,
        domain: isProduction ? '.findsportclub.com' : undefined,
        maxAge: 365 * 24 * 60 * 60 // 1 year
      }
    },

    // React configuration
    react: {
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
      useSuspense: false,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    },

    // Debugging and development
    debug: !isProduction,
    saveMissing: !isProduction,
    missingKeyHandler: (lng, ns, key) => {
      if (!isProduction) {
        console.warn(`Missing translation: ${lng}.${ns}.${key}`);
        // Consider sending missing keys to your backend for tracking
      }
    },

    interpolation: {
      escapeValue: false, // React already protects from XSS
    }
  });

// Initialize custom formatters after i18next is initialized
initFormatter(i18n);

// Hot reload for development
if (import.meta.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept([
    '../locales/en/translation.json',
    '../locales/el/translation.json',
    '../locales/en/login.json',
    '../locales/el/login.json',
    '../locales/en/features.json',
    '../locales/el/features.json',
    '../locales/en/maps.json',
    '../locales/el/maps.json'
  ], () => {
    i18n.reloadResources().then(() => i18n.changeLanguage(i18n.language));
  });
}

export default i18n;